import "./ApplianceRepair.module.css";
import Header from "@/reusable_sections/Header";
import HeroServiceBooking from "./sections/HeroServiceBooking";
import Valuepropositiongrid from "./sections/Valuepropositiongrid";
import ServiceDetails from "./sections/ServiceDetails";
import ApplianceRepairArticle from "./sections/ApplianceRepairArticle";
import ApplianceRepairExpertProfiles from "./sections/ApplianceRepairExpertProfiles";
import ApplianceTestimonials from "./sections/ApplianceTestimonials";
import ApplianceRepairFAQ from "./sections/ApplianceRepairFAQ";
import ReadyToScheduleCTA from "./sections/ReadyToScheduleCTA";
import Booking from "./sections/Booking";
import Footer from "@/reusable_sections/Footer";
export default function ApplianceRepairPage() {
  return <div>
      <Header />
      <HeroServiceBooking />
      <Valuepropositiongrid />
      <ServiceDetails />
      <ApplianceRepairArticle />
      <ApplianceRepairExpertProfiles />
      <ApplianceTestimonials />
      <ApplianceRepairFAQ />
      <ReadyToScheduleCTA />
      <Booking />
      <Footer />
    </div>;
}